module.exports = __webpack_public_path__ + "img/shape-5.f26df507.svg";